/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  CostCenterRestService,
  JobContractDaysPeriodType,
  JobContractStartBasedOnType,
  SystemVarsRestService,
} from '@gh/builder-shared-data';
import { DictionaryService, InitViewService } from '@gh/common-shared';
import { AutocompleteItem, withDisplayAsNameAndDescription } from '@gh/common-shared-data';
import { FilteredDataQuery, getSlicedData } from '@gh/core-data';
import { map$ } from '@gh/rx/operators';

import { Observable } from 'rxjs';

import {
  SystemVarsJobDetails,
  systemVarsJobFromDto,
  systemVarsJobToDto,
} from './model/system-vars-jobs.model';

@Injectable()
export class SystemVarsJobsBusinessService implements InitViewService {
  constructor(private dictionaryService: DictionaryService,
              private restService: SystemVarsRestService,
              private costCenterRest: CostCenterRestService,
  ) {
  }

  initView(): any {
    return {
      contactBasedOnValues: this.dictionaryService.getByEnum(JobContractStartBasedOnType),
      contractPeriodIncludes: this.dictionaryService.getByEnum(JobContractDaysPeriodType),
      sysVarsJob: this.restService.getJob().pipe(map$(systemVarsJobFromDto)),
    };
  }

  save(job: SystemVarsJobDetails): Observable<SystemVarsJobDetails> {
    return this.restService.saveJob(systemVarsJobToDto(job)).pipe(map$(systemVarsJobFromDto));
  }

  loadCC(query: FilteredDataQuery<string>): Observable<AutocompleteItem[]> {
    return this.costCenterRest
      .findAllAutocompleteItemsAsDataSource({ showDeleted: false, searchString: query.filter }).select(query).pipe(
        map$(getSlicedData),
        map$((items) => items.map(withDisplayAsNameAndDescription)));
  }
}
